<template>
	<div>
		<div class="integration-accounts" v-if="accounts.length !== 0">
			<div class="integration-account" v-for="(account, index) in accounts" :key="index">
				<div class="wrapper">
					<div class="integration-account__name">
						<slot v-bind:account="account">
							<!-- Fallback content -->
							{{ account.source.name }} / {{account.meta.browser}} {{account.meta.device}} / {{account.meta.location}}
							<div>
								<span class="badge badge-info">
									Connected at : {{ formatDate(moment, account.created_at, 'DD/MM/YYYY - HH:mm') }}
								</span>
							</div>
						</slot>
					</div>
					<div class="integration-account__actions">
						<button type="button" class="integration-account__remove btn-plain btn-icon-danger" :disabled="isReconnecting" v-if="canRemove" @click="remove(account)" v-tooltip="'Remove'"><i class="material-icons">close</i></button>
						<button type="button" class="integration-account__reconnect btn-plain btn-icon-danger" :class="{'is-loading' : isReconnecting}" @click="reconnect(account)" v-tooltip="'Reconnect'"><i class="material-icons">refresh</i></button>
					</div>
				</div>
			</div>
		</div>
		<div class="integration-accounts-empty p-4 text-center" v-if="accounts.length === 0">{{ emptyListMessage }}</div>
	</div>
</template>

<script>
import {
	formatDate,
	getAxiosErrorMessage,
} from '@/lib/helper';
import userApi from '@/api/user';

export default {
	name: 'integrationAccounts',
	props: {
		name: {
			type: String,
			default: 'Account',
		},
		accounts: {
			type: Array,
			default: () => [],
		},
		emptyMessage: {
			type: String,
			default: 'No accounts connected yet.',
		},
		editable: {
			type: Boolean,
			default: false,
		},
		canRemove: {
			type: Boolean,
			default: true,
		},
		user: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			isReconnecting: false,
		};
	},
	methods: {
		edit(account, index) {
			const key = account._id ? account._id : index;
			this.$emit('edit', key);
		},
		remove(account) {
			// const removedKey = account._id ? account._id : index;
			this.$emit('remove', account);
		},
		reconnect(account) {
			this.isReconnecting = true;
			const params = {};

			const callback = (response) => {
				const newConnection = response.data;
				if (newConnection) {
					const accountIndex = this.accounts.findIndex(currentAccount => currentAccount._id === account._id);
					if (accountIndex !== -1) {
						this.$set(this.accounts, accountIndex, {
							...newConnection,
						});
					}
				}

				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Account Reconnect',
					text: 'Success Reconnecting Account',
				});

				this.isReconnecting = false;
			};

			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Account Reconnect',
					text: message,
				});
				this.isReconnecting = false;
			};

			userApi.reconnect(account._id, params, callback, errorCallback);
		},
		formatDate,
	},
	computed: {
		defaultEmptyMesage() {
			return `No ${this.name} Connected`;
		},
		emptyListMessage() {
			return this.emptyMessage ? this.emptyMessage : this.defaultEmptyMesage;
		},
	},
};
</script>
